<template>
  <div>
    <Header></Header>
    <nav></nav>
    <div class="Center1200">
      <div class="ConHeader">
        <h2>北京商务服务业发展地图参与通道</h2>
      </div>
      <div class="context">
        <p></p>
        <span>
          为帮助会计咨询、法律服务、人力资源、广告营销等商务服务机构扩大宣传，促进项目精准对接，开放“北京商务服务业发展地图”参与通道：
        </span>
        <span>
          请有意向参与的商务服务企业填写企业信息表（见附件），并反馈至邮箱chenfeng@sw.beijing.gov.cn。
        </span>
        <span>
          <a href="http://open.beijing.gov.cn/web/industry-analyze/企业信息表.docx" target="_blank" style="cursor:pointer;text-decoration: underline;">
            <b>附件：企业信息表（可下载）</b>
          </a>
        </span>
      </div>
      <el-button @click="Back()" style="margin-top:47px;">返回</el-button>
    </div>
  </div>
</template>
<script>
import Header from '@/components/header.vue';

export default {
  name: "EntInfo",
  components:{
    Header
  },
  data() {
    return{}
  },
  created() {},
  methods:{
    Back(){
      this.$router.go(-1)
    }
  }
}

</script>

<style scoped>
  nav{
    height: 60px !important;
    background: #BA0132;
  }
  .Center1200{
    width: 1170px;
    min-height: 499px;
    padding: 0px 15px;
    margin: 0 auto;
  }
  .ConHeader{
    height: 65px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid rgb(186,1,50);
  }
  .ConHeader>h2{
    margin: 0px 44px;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  .ConHeader span{
    font-size: 14px;
    color: rgb(249,177,144);
    background: rgb(253,240,220);
    padding:3px 8px;
    border-radius: 5px;
  }
  .context{
    text-align: left;
    font-size: 14px;
  }
  .context p{
    color: #A30014;
    margin: 30px 0px;
    font-size: 16px;
  }
  .context span{
    display: block;
    text-indent: 2em;
    margin-bottom: 15px;
    line-height: 28px;
  }
</style>
